import styles from "../css/skills.module.css";
export const Skills = () => {
  return (
    <div>
    <div id="skills" className={styles.container}>
      <h1 className={styles.heading}>Frontend Skills</h1>
      <div className={styles.toolContainer}>
        <div>
          {/* 1 */}
         
          <a href="https://whatwg.org/">
            <img
              src="https://chiranjeev-thapliyal.vercel.app/svg/html-5.svg"
              alt=""
            />
          </a>
          <h1>HTML5</h1>
        </div>
        <div>
          {/* 2 */}
          <a href="https://www.w3.org/">
            <img
              src="https://chiranjeev-thapliyal.vercel.app/svg/css3.svg"
              alt=""
            />
          </a>
          <h1>CSS3</h1>
        </div>
        <div>
          {/* 3 */}
          <a href="https://www.javascript.com/">
            <img
              src="https://chiranjeev-thapliyal.vercel.app/svg/javascript.svg"
              alt=""
            />
          </a>
          <h1>JAVASCRIPT</h1>
        </div>
        <div>
          {/* 4 */}
          <a href="https://reactjs.org/">
            <img
              src="https://chiranjeev-thapliyal.vercel.app/svg/reactjs.svg"
              alt=""
            />
          </a>
          <h1>REACT</h1>
        </div>
        <div>
          {/* 5 */}
          <a href="https://redux.js.org/">
            <img
              src="https://chiranjeev-thapliyal.vercel.app/svg/redux.svg"
              alt=""
            />
          </a>
          <h1>REDUX</h1>
        </div>
      
        <div>
          {/* 8 */}
          <a href="https://getbootstrap.com/">
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/b2/Bootstrap_logo.svg/1200px-Bootstrap_logo.svg.png"
              alt=""
            />
          </a>
          <h1>BOOTSTRAP</h1>
        </div>
       
       
        <div>
          {/* 9 */}
          <a href="https://git-scm.com/">
            <img
              src="https://chandrashekharjoshi302.github.io/static/media/chakraui.15320604467d004df871.png"
              alt=""
            />
          </a>
          <h1>CHAKRA UI</h1>
        </div>
        <div>
          {/* 9 */}
          <a href="https://git-scm.com/">
            <img
              src="data:image/png;base64,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"
              alt=""
            />
          </a>
          <h1>POSTMAN</h1>
        </div>
      </div>
    </div>
    <div className={styles.backend}>
    <h1 className={styles.heading}>Backend Skills</h1>
    <div className={styles.toolContainer}>
    <div>
          {/* 6 */}
          <a href="https://nodejs.org/en/">
            <img
              src="https://chiranjeev-thapliyal.vercel.app/svg/nodejs.svg"
              alt=""
            />
          </a>
          <h1>NODE JS</h1>
        </div>
        <div>
          {/* 9 */}
          <a href="https://git-scm.com/">
            <img
              src="https://chandrashekharjoshi302.github.io/static/media/expressjs.b1ea2a56a1684a950424.webp"
              alt=""
            />
          </a>
          <h1>EXPRESS</h1>
        </div>
        <div>
          {/* 7 */}
          <a href="https://www.mongodb.com/">
            <img
              src="https://chandrashekharjoshi302.github.io/static/media/mongodb.7a16fc61d457c9e340e2.png"
              alt=""
            />
          </a>
          <h1>MONGODB</h1>
        </div>
        <div>
          {/* 9 */}
          <a href="https://git-scm.com/">
            <img
              src="https://chiranjeev-thapliyal.vercel.app/svg/git.svg"
              alt=""
            />
          </a>
          <h1>GIT</h1>
        </div>
        </div>
        </div>
    </div>
   
    
  );
};
